import Input from 'antd/lib/input'

export const TextAreaWidget = (props: {
    value: string
    onChange: (value: string) => void
    disabled?: boolean
}) => {
    const { value, onChange, disabled } = props

    return (
        <Input.TextArea
            rows={6}
            autoSize={{ minRows: 4, maxRows: 10 }}
            placeholder="Enter your text here..."
            value={value}
            onChange={e => {
                onChange(e.target.value)
            }}
            disabled={disabled}
        />
    )
}
